export default __webpack_public_path__ + "static/media/dr-login.c9873412.png";